import React, {Component} from 'react';
import {connect} from "react-redux";
import './Gallery.css';
import SVG from "react-inlinesvg";
import closeicon from "../../assets/close.svg";
import AccessControl from "../../utils/AccessControl";
import rightArrow from '../../assets/arrow-right.svg';
import {Link} from "react-router-dom";
import $ from "jquery";

class Gallery extends Component {
    constructor(props) {
        super(props);
    };
    componentDidMount() {
        $('#gallery-modal').css({
            'position': 'fixed',
            'z-index': '100',
        });
    }

    changeImage = (id) => {
        this.props.gallery_Info(id);
    }
    change = (direction) =>{
        let active = this.props.active_id;
        let images = this.props.unit.s3_links;
        let current = "";
        let next = "";
        images.filter((l, x)=> {
            if(l.id === active){
                current = images.indexOf(l);
               if(direction === "left"){
                    next = (current + images.length - 1) % images.length;
                }else{
                       next = (current + 1) % images.length;
                }
                this.props.gallery_Info(images[next].id);
            }
        })
    }
    render() {
        let images = this.props.unit.s3_links;
        let active = "";
        return(

                <tr>
                 <td className="modal-overlay"> <div className="modal gallery-modal modal-function" id="gallery-modal">
                     <div className="modal-content ">
                         <div onClick={() => this.props.toggleModal('gallery', false)} className="closeBtn">
                             <SVG src={closeicon}/>
                         </div>
                         <div className="slider">
                             <div className="slider-content">
                                 <div className="control left-arrow" onClick={() => this.change('left')}><SVG src={rightArrow}/></div>
                                 {this.props.active_id !== 'undefined' &&
                                 <div className="active-slide">{images.map((image, i) =>{
                                     if(image.id === this.props.active_id){
                                         return(
                                             <div className="active-img-container" key={i}>
                                                 <img src={image.s3_location} alt=""/>
                                                 <span className="banner-info">{image.ad_size} {image.note !== "" && image.note !== null ? image.note : "" }</span>
                                             </div>
                                         )
                                     }
                                 })}
                                 </div>}
                                 <div className="control right-arrow" onClick={() => this.change('right')}><SVG src={rightArrow}/></div>
                                 <div className="slider-container">
                                     <ul className="slider-list">
                                         {images.map((links, i) => {
                                             return (
                                                 <li className='slider-image' key={i} onClick={() => this.changeImage(links.id)}>
                                                     <img src={links.s3_location} alt=""/>
                                                 </li>
                                             )
                                         })}
                                     </ul>
                                 </div>
                             </div>
                         </div>
                     </div>
                 </div></td>
                </tr>
        )
    }
}
export default connect(null)(Gallery);
